import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import clsx from 'clsx'
import { BulkAddElementInputWithMetadata } from 'models/getProjectElementNodesInput'
import React from 'react'
import AddProjectWarningDialog from '../AddProjectWarningDialog'
import { useBulkAddBarStyles } from './bulkAddBarStyles'

export interface BulkAddBarLeftSectionProps {
    addBulkAddItemsToProject: () => void
    selectedBulkAddElements?: BulkAddElementInputWithMetadata[]
    isBetaWorkspaceToggleEnabled?: boolean
}

const BulkAddBarLeftSection = ({
    selectedBulkAddElements,
    addBulkAddItemsToProject,
    isBetaWorkspaceToggleEnabled,
}: BulkAddBarLeftSectionProps) => {
    const classes = useBulkAddBarStyles({ isBetaWorkspaceToggleEnabled })
    const [showAddProjectDialog, setShowAddProjectDialog] = React.useState(false)
    const hasManufacturerOptions = React.useMemo(() => {
        return selectedBulkAddElements?.some(
            (element) =>
                element.elementType === 'PRODUCTTYPE' &&
                element.isBasedFromManufacturerOption
        ) ?? false
    }, [selectedBulkAddElements])

    const handleClickAddToProject = React.useCallback(() => {
        if (hasManufacturerOptions) {
            setShowAddProjectDialog(true)
        } else {
            addBulkAddItemsToProject()
        }
    }, [hasManufacturerOptions, addBulkAddItemsToProject])

    const handleAddToProjectDialogClose = React.useCallback(() => {
        setShowAddProjectDialog(false)
    }, [])

    const handleContinueAddToProject = React.useCallback(() => {
        setShowAddProjectDialog(false)
        addBulkAddItemsToProject()
    }, [addBulkAddItemsToProject])

    return (
        <GridItem className={classes.searchFieldContainer}>
            <GridContainer>
                <GridItem className={classes.elementTypeItem}>
                    <Button
                        disableRipple
                        startIcon={
                            <AddCircleOutlineIcon
                                className={
                                    isBetaWorkspaceToggleEnabled
                                        ? classes.startIcon
                                        : ''
                                }
                            />
                        }
                        className={clsx(
                            classes.elementTypeButton,
                            isBetaWorkspaceToggleEnabled
                                ? classes.selectedElementsButton
                                : ''
                        )}
                        classes={{
                            endIcon: classes.checkIcon,
                        }}
                        onClick={handleClickAddToProject}
                        data-testid={`addSelectedItemsButton`}
                    >
                        Add Selected Elements to Project
                    </Button>
                </GridItem>

                <GridItem>
                    <Typography className={classes.confirmationText}>
                        {selectedBulkAddElements?.length} element
                        {selectedBulkAddElements &&
                        selectedBulkAddElements?.length > 1
                            ? 's '
                            : ' '}
                        selected
                    </Typography>
                </GridItem>
            </GridContainer>
            <AddProjectWarningDialog
                open={showAddProjectDialog}
                onCancel={handleAddToProjectDialogClose}
                onSubmit={handleContinueAddToProject}
            />
        </GridItem>
    )
}

export default BulkAddBarLeftSection
